"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Item = require("./Item.styles");
var _Item2 = require("./Item.labels");
var _hooks = require("../../../hooks");
var _A = require("../../../UI/A");
var _Preloader = require("../../../UI/Preloader");
var _Img = require("../../../UI/Img");
var _ItemTypes = require("./partials/ItemTypes");
var _NewTag = require("./partials/ItemTag/partials/tags/NewTag");
var _bad_image = _interopRequireDefault(require("./resources/bad_image.png"));
var _itemLoader = _interopRequireDefault(require("./resources/item-loader.json"));
var _AttachedTag = require("./partials/ItemTag/partials/tags/AttachedTag");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Item = props => {
  const {
    view = 'default',
    isNew = false,
    isAttached = false,
    url = '',
    banner,
    onItemClick,
    label,
    optionalData,
    isMobileSupported,
    itemTypes,
    itemBannerChildren,
    title,
    subTitle,
    duration,
    type,
    itemInfoChildren,
    itemExtraInfoChildren
  } = props;
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const getLabel = (0, _hooks.useLabels)({
    labels: _Item2.labels
  });
  const [isReady, setIsReady] = (0, _react.useState)(false);
  const [isItemOver, setIsItemOver] = (0, _react.useState)(false);
  const styles = (0, _Item.useStyles)(props, isReady, isItemOver);
  const bannerWidth = view === 'horizontal' ? type === 'book' ? '100%' : 100 : 220;
  const bannerHeight = view === 'horizontal' ? type === 'book' ? 'auto' : 85 : 186;
  const handleItemIsReady = () => {
    setIsReady(true);
  };
  const handleMouseEnter = () => {
    setIsItemOver(true);
  };
  const handleMouseLeave = () => {
    setIsItemOver(false);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("article", {
    className: styles['cc-Item'],
    children: [!isReady && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Item__preloader'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Preloader.Preloader, {
        url: _itemLoader.default
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-Item__tags'],
      children: [isNew && /*#__PURE__*/(0, _jsxRuntime.jsx)(_NewTag.NewTag, {
        label: getLabel('new'),
        isWithSpout: view === 'horizontal' ? false : true,
        view: view
      }), isAttached && /*#__PURE__*/(0, _jsxRuntime.jsx)(_AttachedTag.AttachedTag, {
        label: getLabel('attached'),
        isWithSpout: view === 'horizontal' ? false : true,
        view: view
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Item__container'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
        isBtnView: true,
        view: "text",
        customStyle: {
          width: '100%'
        },
        to: url,
        target: "_blank",
        onClick: onItemClick,
        category: "tile",
        label: label,
        optionalData: optionalData,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: styles['cc-Item__main-content'],
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: styles['cc-Item__banner'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Img.Img, {
              onLoad: handleItemIsReady,
              src: banner,
              fallback: _bad_image.default,
              alt: title,
              width: bannerWidth,
              height: bannerHeight,
              borderRadius: {
                borderRadius: 10
              }
            }), view === 'default' && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: styles['cc-Item__banner-content'],
              children: [!isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ItemTypes.ItemTypes, {
                itemTypes: itemTypes,
                isMobileSupported: isMobileSupported,
                view: view
              }), itemBannerChildren]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: styles['cc-Item__content'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: styles['cc-Item__title'],
              children: title
            }), view === 'horizontal' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ItemTypes.ItemTypes, {
              itemTypes: itemTypes,
              isMobileSupported: isMobileSupported,
              view: view
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: styles['cc-Item__info'],
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: styles['cc-Item__sub-title'],
                children: subTitle
              }), Number(duration) > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: styles['cc-Item__duration'],
                children: type === 'course' ? duration === 999 ? `${getLabel('yearly')}` : `${duration} ${getLabel('hours')}` : `${Number(duration) > 120 ? '120+' : duration} ${getLabel('minutes')}`
              })]
            }), itemInfoChildren]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-Item__extra-content'],
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: styles['cc-Item__extra-info'],
              children: itemExtraInfoChildren
            })
          })]
        })
      })
    })]
  });
};
exports.Item = Item;